export default {
  KINGDOM: 'Kingdom',
  PHYLUM: 'Phylum',
  CLASS: 'Class',
  ORDER: 'Order',
  GROUP: 'group',
  FAMILY: 'Family',
  SPECIES: 'Species',
  NO_EVENT_NAME: 'NO_EVENT_NAME',
  KINGDOMS: { MITRA_PWA: 'mitraPwa' },
  ONBOARDING: 'onboarding',
  PROFILE: 'profile',
  LANGUAGE: 'language',
  NAME: 'name',
  GENDER: 'Gender',
  AGE: 'age',
  MOBILE_NUMBER: 'mobileNumber',
  OTP: 'otp',
  WORK: 'Work',
  CITY: 'City',
  AREA: 'Area',
  HOME: 'home',
  VIEW: 'PageLoad',
  EDIT: 'Edit',
  LOCATION: 'Area_Preferences',
  EDUCATION: 'educationQualification',
  MARITAL_STATUS: 'maritalStatus',
  TIME_TO_JOIN: 'timeToJoin',
  WORK_EXPERIENCE: 'workExperience',
  INTERESTED_JOBS: 'interestedJobs',
  SKILLS_OWNERSHIP: 'skillsAndOwnership',
  JOB_PREF: 'jobAndShiftPreference',
  CONNECTIONS: 'mitraLeaderConnections',
  SUCCESS: 'success',
  ADD: 'Add',
  JOB_DISC: 'jobDiscovery',
  JOB: 'job',
  JOB_APP: 'jobApplication',
  DOCUMENTS: 'documents',
  ACTION_ENTER_MOBILE_NUMBER: 'Action_Enter_Mobile_Number',
  ACTION_ENTER_OTP: 'Action_Enter_OTP',
  ACTION_SEND: 'Action_Send',
  ACTION_RESEND: 'JobSeekerClicksResendOtp',
  ERROR_MESSAGE: 'Error_Message',
  ACTION_SKIP: 'Action_Skip',
  ACTION_SHARE_MITRA_ON_WHATSAPP: 'JobSeekerSharesMitraOnWhatsApp',
  ACTION_VIEW_JOB: 'JobSeekerViewsJob',
  ACTION_PLAY_VIDEO: 'Action_Play_Video',
  ACTION_TRACK_JOB_APPLICATION: 'JobSeekerTracksJobApplication',
  ACTION_CLICKS_VIEW_JOB: 'JobSeekerClicksViewJob',
  ACTION_CLICKS_CALL: 'JobSeekerClicksCall',
  ACTION_SHARE_JOB: 'JobSeekerSharesJob',
  ACTION_APPLY_JOB: 'jobSeekerAppliesJob',
  ACTION_CLICK_APPLY_JOB: 'JobSeekerClicksApply',
  ACTION_CLICK_CALL: 'JobSeekerClicksCall',
  ACTION_SELECT_CALL_CONNECTION_STATUS: 'CallConnectionStatus',
  ACTION_JOB_NOT_INTERESTED: 'JobNotInterested',
  ACTION_CALL_MITRA_LEADER: 'jobSeekerCallsMitraTelecaller',
  ACTION_RATE_JOBS: 'JobSeekerRatesJobPosts',
  ACTION_EDIT_DOCUMENTS: 'jobSeekerEditsDocuments',

  // V2 Events
  PAGE_LOAD: 'PageLoad',
  UNKNOWN: 'UNKNOWN',
  LATEST_SOURCE: 'latestSource',
  SCREEN: 'screen',
  PRODUCT: 'product',
  SUBMIT_MOBILE: 'JobSeekerSubmitsMobileNumber',
  SUBMIT_OTP: 'JobSeekerSubmitsOtp',
  OTP_ERROR: 'ErrorOtpValidationFailed',
  PROFILE_PHOTO: 'profilePhoto',
  CITY_PREF: 'cityPreference',
  AREA_PREF: 'areaPreferences',
  HOME_CITY: 'homeCity',
  WORK_EXP_DETAILS: 'workExperienceDetails',
  PROFILE_SCREEN: 'jobSeekerProfile',
  CLICK_DOCUMENT: 'JobSeekerClicksUploadDocument',
  UPLOADS_FROM_GALLERY: 'JobSeekerUploadsFromGallery',
  UPLOADS_BY_CAMERA: 'JobSeekerUploadsByCamera',
  UPLOAD_DOCUMENT_SCREEN: 'uploadDocument',
  UPLOAD_AGAIN: 'JobSeekerUploadsDocumentAgain',
  ERROR_BLUR: 'ErrorDocumentBlur',
  CLEAR_DOC: 'ClearDocument',
  SAVES_DOC: 'JobSeekersSavesDocument',
  SUBMITS_DOC: 'JobSeekerSubmitsDocument',
  PLAYS_VIDEO: 'JobSeekerPlaysVideo',
  STOPS_VIDEO: 'JobSeekerStopsVideo',
  START_SEARCH: 'JobSeekerStartsJobSearch',
  VALUE_PROPOSITION: 'valueProposition',
  JOB_PAGE_SHARE_WHATS: 'jobSeekerSharesJobOnWhatsApp',
  JOB_PAGE_SHARE: 'jobSeekerSharesJob',
  JOB_SEEKER_CALLS_TELE: 'jobSeekerCallsMitraTelecaller',
  TRACK_APPLICATION: 'trackJobApplication',
  NAME_AGE_GENDER: 'nameAgeGender',
  JOB_SEEKER_SUBMITS_NAME: 'JobSeekerSubmitsNameAgeGender',
  FIRST_TIME_JOB_APP: 'JobSeekerSubmitsFirstJobApplication',
  JOB_SEEKER_CLICKS_JOB_ROLE_FILTER: 'JobSeekerClicksJobRoleFilter',
  JOB_SEEKER_CLICKS_SALARY_FILTER: 'JobSeekerClicksSalaryFilter',
  JOB_SEEKER_CLICKS_AREA_FILTER: 'JobSeekerClicksAreaFilter',
  JOB_SEEKER_FILTERS_JOB_ROLES: 'JobSeekerFiltersJobRoles',
  JOB_SEEKER_FILTERS_SALARY: 'JobSeekerFiltersSalary',
  JOB_SEEKER_FILTERS_AREAS: 'JobSeekerFiltersAreas',
  JOB_SEEKER_ADDS_MITRA_TO_HOME_SCREEN: 'JobSeekerAddsMitraToHomeScreen',
  JOB_SEEKER_ALLOWS_NOTIFICATIONS_FOR_JOBS: 'JobSeekerAllowsNotificationsForJobs',
  JOB_SEEKER_OPTS_INTO_WHATSAPP: 'JobSeekerOptsIntoWhatsapp',

  // FB Login
  LOGIN_OPTION: 'mobileNumberOrFacebookLogin',
  FB_LOGIN_CLICK: 'JobSeekerClicksFacebookLogin',
  MOBILE_AUTH_CLICK: 'JobSeekerClicksMobileNumberAuthentication',
  FB_LOGIN_SUCCESS: 'FacebookLoginSuccessful',
  FB_FAILED: 'FacebookLoginFailed',

  CARD_LOAD: 'CardLoad',
  MOBILE_NUMBER_CARD: 'mobileNumberCard',
  SUBMITS_MOBILE: 'JobSeekerSubmitsMobileNumber',
  RESEND_OTP_JOB: 'JobSeekerClicksResendOtp',
  OTP_CARD: 'otpCard',
  EXPECTED_MIN_SALARY: 'expectedMinSalary',

  // Mitra
  MITRA_LEADER: 'mitraLeader',
  MITRA_LEADER_PROFILE: 'MitraLeaderProfile',
  JOB_SEEKER_CLICKS_VIEW_JOB: 'JobSeekerClicksViewJob',
  JOB_SEEKER_CLICKS_MITRA_PROFILE: 'JobSeekerClicksMitraProfile',
};
